<div class="flex-col w100">
  @if (label() || helperKey()) {
    <div class="flex-row gap-8">
      @if (label()) {
        <mat-label [ngClass]="{'label-required': isRequired()}">{{ label() }}</mat-label>
      }
      @if (helperKey()) {

          <vl-aide-context class="ml-auto">
            <ng-template vlAideContent>
              <div class="aide-section-text">
                {{ 'help.'+helperKey() | trans }}
              </div>
            </ng-template>
          </vl-aide-context>

      }
    </div>
  }
  <mat-form-field appearance="outline"
                  subscriptSizing="fixed"
                  class="mf-no-chrome w-full"
                  [class.no-subscript]="!showSubscript()"
                  [class.no-min-width]="!minWidth()">
    <div class="flex-col" matPseudoControl
         [required]="isRequired()"
         [errorState]="isRequiredError()">
      @if (popoverOnly()) {
        <div #menuTrigger="matMenuTrigger"
             [matMenuTriggerFor]="selectAutocomplete"
             (menuOpened)="onMenuOpened()">
        </div>

      } @else {
        <div class="flex-row">
          <vl-chips
            [matMenuTriggerFor]="selectAutocomplete"
            (action)="!isDisabled() && openMenu(menuTrigger);"
            (menuOpened)="onMenuOpened()"
            #menuTrigger="matMenuTrigger"
            [disabled]="isDisabled()"
            [iconLeft]="buttonIcon()"
            [state]="buttonColor()"
            [iconRight]="buttonIconRight()"
            [loading]="loading()"
            [contentHeight]="type() === 'template' && !!selectedOption()"
            [ngClass]="{'display-none': popoverOnly()}"
          >
            @if (type() === 'template' && template() && selectedOption() && templateButton()) {
              <ng-container *ngTemplateOutlet="template(); context: { $implicit: selectedOption(), selected: true }"></ng-container>
            } @else {
              <span class="body-1">
              {{ buttonText() }}
              </span>
            }
          </vl-chips>
        </div>
      }
    </div>
  </mat-form-field>

<mat-menu #selectAutocomplete class="select-autocomplete-menu">
  <div class="min-w-300 px-12 flex-col gap-4">
    <div class="flex-col w100">
      @if (header()) {
        <ng-container [ngTemplateOutlet]="headerAutocomplete"></ng-container>
      }
      <div class="flex-row w100 align-end">
        <div class="flex-row w100 align-center gap-4 mt-16" (click)="$event.stopPropagation()">
          <vl-input-search class="grow" [(value)]="searchValue" (keydown)="$event.stopPropagation()" [canCreate]="canCreate()" (createAction)="onCreate.emit()"/>
          @if (optionMenu()) {
            <mat-menu #menuOptionMenu>
              <div class="flex-row" (click)="closeMenuOption($event)">
                <ng-container [ngTemplateOutlet]="templateOptionMenu"></ng-container>
              </div>
            </mat-menu>
            <mat-icon
              [matMenuTriggerFor]="menuOptionMenu"
              (click)="openMenu(menuTriggerOption)"
              #menuTriggerOption="matMenuTrigger"
            >more_horiz</mat-icon>
          }
        </div>
        @if (sideSearch()) {
          <ng-container [ngTemplateOutlet]="sideSearchAutocomplete"></ng-container>
        }
      </div>
      @if (subSearch()) {
        <ng-container [ngTemplateOutlet]="subSearchAutocomplete"></ng-container>
      }
    </div>
    <div class="flex-col gap-4 search-results relative" [style.max-height]="maxHeight()">
      <div class="background-scroll-top"></div>
      @if (value() && this.mode() === 'select') {
        <div class="p-4">
          <vl-chips [contentHeight]="true" [state]="'active'" iconRight="close"
                    (action)="unSelect(); menuTrigger()?.closeMenu()">
            @if (type() === 'template' && template() && selectedOption()) {
              <ng-container *ngTemplateOutlet="template(); context: { $implicit: selectedOption(), selected: true }"></ng-container>
            } @else {
              <div class="w100 flex-row justify-between">
                {{ name() }}
                @if (subname()) {
                  <span class="on-disabled">{{ subname() }}</span>
                }
              </div>
            }
          </vl-chips>
        </div>
      }
      @if (emptyPlaceholder() && optionsFiltered()?.length === 0) {
        <div class="caption flex-container-row justify-center">{{ emptyPlaceholder() }}</div>
      }
      @if (suggestions()?.length && !searchValue()?.length && !value()) {
        <div class="flex-col mb-15 bg-canvas py-8 border-8 border-secondary">
          <div class="flex-row w100 justify-center">
            <span class="body-2">{{ 'select_autocomplete.suggestions' | trans }}</span>
          </div>
          @for (option of suggestions(); track option.value) {
            <ng-container [ngTemplateOutlet]="optionTemplate"
                          [ngTemplateOutletContext]="{ option: option, index: $index }"></ng-container>
          }
        </div>
      }
      @for (option of optionsFiltered(); track option.value) {
        <ng-container [ngTemplateOutlet]="optionTemplate"
                      [ngTemplateOutletContext]="{ option: option, index: $index }"></ng-container>
      } @empty {
        <ng-container [ngTemplateOutlet]="empty"></ng-container>
      }
      @if (footer()) {
        <ng-container [ngTemplateOutlet]="footerAutocomplete"></ng-container>
      }

      <div class="background-scroll-bottom"></div>
    </div>
  </div>
</mat-menu>

<ng-template #optionTemplate let-option="option" let-index="index">
  <div class="p-4">
    <vl-chips [id]="'option'+index" [contentHeight]="true"
              (action)="selectOption(option); menuTrigger()?.closeMenu()">
      @if (type() === 'template') {
        <ng-container *ngTemplateOutlet="template(); context: { $implicit: option }"></ng-container>
      } @else if (type() === 'userInfos') {
        <vl-user-info-card [userInfosId]="option.id"></vl-user-info-card>
      } @else if (type() === 'default') {
        @if (option.title) {
          <div class="flex-col w100">
            <div class="flex-row w100 justify-center">
              <span class="caption-2">{{ option.title }}</span>
            </div>
            <div class="flex-row w100 justify-between">
              <span class="body-1">{{ option.name }}</span>
              @if (option.subname) {
                <span class="on-disabled">{{ option.subname }}</span>
              }
            </div>
          </div>
        } @else {
          <div class="flex-row w100 justify-between">
            <span class="class-body-2">{{ option.name }}</span>
            @if (option.subname) {
              <span class="on-disabled">{{ option.subname }}</span>
            }
          </div>
        }
      }
    </vl-chips>
  </div>
</ng-template>

<ng-template #empty>
  <ng-content select=".empty-autocomplete"></ng-content>
</ng-template>
<ng-template #headerAutocomplete>
  <ng-content select=".header-autocomplete"></ng-content>
</ng-template>
<ng-template #footerAutocomplete>
  <ng-content select=".footer-autocomplete"></ng-content>
</ng-template>
<ng-template #sideSearchAutocomplete>
  <ng-content select=".side-search-autocomplete"></ng-content>
</ng-template>
<ng-template #subSearchAutocomplete>
  <ng-content select=".subsearch-autocomplete"></ng-content>
</ng-template>
<ng-template #templateOptionMenu>
  @if (optionMenu()) {
      <ng-container [ngTemplateOutlet]="optionMenu()"></ng-container>
  }
</ng-template>
</div>
